export enum Icons {
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  FlagEn = 'flag-en',
  FlagDe = 'flag-de',
  FlagFr = 'flag-fr',
  IconPdp = 'icon-pdp',
  IconBulkOrder = 'icon-bulk-order',
  AddToCart = 'add-to-cart',
  Check = 'check',
  Remove = 'remove',
  Exportfile = 'exportfile',
  Deletecart = 'deletecart',
  Pdf = 'pdf',
  PaginationArrowRight = 'pagination-arrow-right',
  PaginationArrowRightDisable = 'pagination-arrow-right-disable',
  PaginationArrowLeft = 'pagination-arrow-left',
  PaginationArrowLeftDisable = 'pagination-arrow-left-disable',
  ListIcon = 'list-icon',
  GridIcon = 'grid-icon',
  Import = 'import',
  Upload = 'upload',
  XIcon = 'x-icon',
  Info = 'info',
  Filter = 'filter',
  Track = 'track',
  Open = 'open',
  BackOrder = 'back-order',
  Closed = 'closed',
  Cancelled = 'cancelled',
  Failed = 'failed',
  AddToCartPrimary = 'add-to-cart-primary',
  ExpandImage = 'expand-image',
  ShrinkImage = 'shrink-image',
  Promotion = 'promotion',
  InfoBlack = 'info-black',
  ModalXIcon = 'modal-x-icon',
  FreightIcon = 'freight-icon',
  Edit = 'edit',
  CancelledStatus = 'cancelled-x-icon',
  OrderForm = 'order-form-plp',
}
